<template>
  <sdPageHeader :title="$t('pages.demos.detail.title')" />
  <Main>
    <sdCards>
      <a-form layout="vertical" :model="demoDetail" @submit="handleFinishForm">
        <a-form-item :label="$t('pages.demos.detail.label-email')">
          <a-input v-model:value="demoDetail.email" :placeholder="$t('pages.demos.detail.namespace-email')" required />
        </a-form-item>
        <a-form-item :label="$t('pages.demos.detail.label-url')">
          <a-input v-model:value="demoDetail.demo_url" :placeholder="$t('pages.demos.detail.namespace-url')" required />
        </a-form-item>
        <a-row :gutter="16">
            <a-col :span="6">
            <a-form-item :label="$t('pages.demos.detail.label-start')">
              <span> {{ dateFormat(demoDetail.created_at) }}</span>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item :label="$t('pages.demos.detail.label-end')">
              <span> {{ dateFormat(demoDetail.expired_at) }}</span>
            </a-form-item>
          </a-col>

          
        </a-row>
        <a-form-item :label="$t('pages.demos.detail.label-extend-demo')">
          <a-input v-model:value="demoDetail.day" type="number" :placeholder="$t('pages.demos.detail.namespace-day')" />
        </a-form-item>

        <a-form-item :label="$t('pages.demos.detail.label-state')">
          <a-space align="baseline">
            <a-switch v-model:checked="demoDetail.is_active" />
            <p>{{ demoDetail.is_active ? $t('common.1') : $t('common.0') }}</p>
          </a-space>
        </a-form-item>

        <sdButton size="default" htmlType="submit" type="primary">{{ $t('common.save') }} </sdButton>
      </a-form>
    </sdCards>
  </Main>
</template>

<script>
import { Main } from '@/view/styled';
import { dateToTr } from '@/utility/helper.js';

export default {
  name: 'DemoDetail',
  components: {
    Main,
    dateToTr,
  },
  data() {
    return {
      demoDetail: {},
      detail_id: this.$route.params.id,
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    handleFinishForm() {
      this.$appAxios.post(this.$endpoints.demos_update_demo, this.demoDetail).then(response => {
        if (response.data.status === true) {
            this.getDetail();
          this.$message.success(this.$t('common.success-message'));
        } else {
          this.$message.error(this.$t('common.error-message'));
        }
      });
    },
    getDetail() {
      this.$appAxios.post(this.$endpoints.demos_detail, { id: this.detail_id }).then(response => {
        if (response.data.status === true) {
          this.demoDetail = response.data.data;
          this.demoDetail.is_active = this.demoDetail.is_active == 1 ? true : false;
        } else {
          this.$message.error(this.$t('common.error-message'));
        }
      });
    },
    dateFormat(value) {
      return dateToTr(value);
    },
  },
};
</script>
